import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" {...props}><g fill="none" fillRule="evenodd"><path d="M0 0h16v16H0z" /><path fill="#2E455B" fillRule="nonzero" d="M9.833 7.983l-4.56 4.83a1 1 0 101.454 1.373l5.21-5.519a1 1 0 00-.002-1.375L6.725 1.81a1 1 0 10-1.45 1.378l4.558 4.794z" /></g></svg>;